import "../../App.css";
import Footer from "../../components/Footer";
import Warning from "../../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';



const Home = () => {
  
  return (
    <div className="App" style={{ margin: "-8px" }}>
    
      <HelmetProvider>
        <Helmet>
          <title>Complete Portfolio</title>
          <meta
            name="Jack Frederick, Complete Portfolio"
            content="A fully self made, and self hosted portfolio site."
            data-react-helmet="true"
            description="A fully self made, and self hosted portfolio site."
            author="Jack Frederick"
          />
        </Helmet>
      </HelmetProvider>
      <Warning></Warning>
      <header className="Home">
        <br></br>
        <div className="screenBox Minsize">
          <p className="Homethick pushdownindex">Let's get you signed up!</p>
          <p className="Homemid">
          </p>
          <br></br>
          <a
            className="Homesmall ats"
            style={{ color: "black" }}
            href="/resume"
          >
            Next Step: Create a Plex Account
          </a>
          <br></br>
          <br></br>
          <p className="Homesmall">
            This site is completely hand made, and self hosted by me.
          </p>
        </div>
      </header>
      <Footer></Footer>
    </div>
  );
};

export default Home;